module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-600-b01250b38f0ef1dc59107894d37711ec.ttf";